import { useUserTypeSwitch } from 'hooks/useUserTypeSwitch';

export const useNumSettingsMenuItems = (): number => {
  return useUserTypeSwitch<number>({ Agency: 6, B2B: 5 });
};
